import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap';
import { ConfirmComponent } from 'app/shared/confirm/confirm.component';
import { AuthenticationStore } from 'app/permission/services/authentication.store';

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<any> {

  constructor(private modalService: BsModalService, private authenticationStore: AuthenticationStore) {}

  canDeactivate(component: any): Observable<boolean> | boolean {
    if (!this.authenticationStore.isLoggedIn() || !this.authenticationStore.hasToken()) {
      return true;
    }
    if (component.isDirty) {
      const modal = this.modalService.show(ConfirmComponent);
      const confirmComponent: ConfirmComponent = modal.content;
      return confirmComponent.confirmed.asObservable().pipe(tap((confirmedValue: boolean) => {
        modal.hide();
        if (component.reset && confirmedValue) {
          component.reset();
        }
      }));
    }
    return true;
  }

}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/unsaved-changes/unsaved-changes.guard.ts